const MESSAGES = {
    FIELD_REQUIRED: 'This field is required.',
    ENTER_EMAIL_ADDRESS: 'Enter Email Address.', 
    ENTER_PASSWORD: 'Enter Password.', 

    ENTER_VALID_EMAIL_ADDRESS: 'Enter Valid Email Address.',
    ENTER_VALID_MOBILE_NUMBER: 'Enter Valid Mobile Number.', 
    ENTER_VALID_ALT_MOBILE_NUMBER: 'Enter Valid Alternate Mobile Number.', 

    MOBILE_NUMBER_TEN_DIGIT: 'Mobile Number should be 10 digit only.', 
    ALT_MOBILE_NUMBER_TEN_DIGIT: 'Alternate Mobile Number should be 10 digit only.', 
}

export default MESSAGES;